module.exports = __webpack_public_path__ + "img/head-side-cough-slash.140ae8a6.svg";